
import { useStore } from 'vuex'
import { defineComponent, ref, onMounted, computed, toRefs, reactive } from 'vue'
import swal from 'sweetalert2'
import Form from './Form.vue'

export default defineComponent({
  components: {
    Form
  },
  setup () {
    const form = reactive({
      id: '',
      code: '',
      name: '',
      territory_manager_id: '1',
      district_id: '1',
      is_active: 0,
    })
    const form_action = ref('save')
    const store = useStore()
    const visible = ref(false)

    const fields = ref([
      {
        title: 'Zone Code',
        dataIndex: 'code',
      },
      {
        title: 'Zone Name',
        dataIndex: 'name',
      },
      {
        title: 'Default RTM',
        dataIndex: 'territory_manager.full_name',
      },
      {
        title: 'District Codes',
        dataIndex: 'district.district_code',
      },
      // {
      //   title: "Is Active",
      //   dataIndex: "is_active",
      //   align: 'center',
      //   slots: { customRender: "is_active" }
      // },
      {
        title: 'Action',
        dataIndex: 'action',
        slots: {customRender: 'action'},
        align: 'center'
      },
    ])

    const index = (payload = {page: 1}) => {
      store.dispatch('Zone/index', payload)
    }

    const editRecord = (record: any) => {
      form_action.value = 'update'
      const {id, code, name, territory_manager_id, district_id} = toRefs(form)
      id.value = record.id
      code.value = record.code
      name.value = record.name
      territory_manager_id.value = record.territory_manager_id
      district_id.value = record.district_id
      visible.value = true
    }

    const createRecord = () => {
      form_action.value = 'save'
      const {id, code, name, territory_manager_id, district_id} = toRefs(form)
      id.value = ''
      code.value = ''
      name.value = ''
      territory_manager_id.value = ''
      district_id.value = ''
      visible.value = true
    }

    const deleteRecord = (record: any) => {
      store.dispatch('Zone/destroy', record.id)
    }

    const handleSaving = (record: any) => {
      form_action.value == 'save' ? storeRecord(record) : updateRecord(record)
    }

    const storeRecord = (payload = {}) => {
      store
          .dispatch('Zone/store', payload)
          .then(() => (visible.value = false))
    }

    const updateRecord = (payload = {}) => {
      store
          .dispatch('Zone/update', payload)
          .then(() => (visible.value = false))
    }

    const filterRecord = (payload: any) => {
      index(payload)
    }

    const items = computed(() => store.getters['Zone/items'])
    const loading = computed(() => store.getters['Zone/status'])

    onMounted(index)

    return {
      loading,
      items,
      fields,
      visible,
      form,
      editRecord,
      deleteRecord,
      storeRecord,
      createRecord,
      updateRecord,
      handleSaving,
      filterRecord
    }
  }

})
